<template>
	<v-container fluid class="inbox py-12 bg-f5f">
		<v-layout align-center class="space-x-8">
			<v-flex shrink>
				<v-layout align-center>
					<v-icon size="36" color="primary" class="mr-2">
						mdi-inbox-arrow-down
					</v-icon>
					<base-text h1 class="mt-1">Smart Inbox</base-text>
				</v-layout>
			</v-flex>
			<v-layout class="space-x-2">
				<v-card width="310">
					<v-card-text class="px-9 pt-4 pb-6">
						<v-layout>
							<v-icon size="32" class="text-f57">mdi-reload</v-icon>
							<v-flex class="ml-6">
								<base-h1>6</base-h1>
								<base-text h2 normal>Processing</base-text>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-card width="310">
					<v-card-text class="px-9 pt-4 pb-6">
						<v-layout>
							<v-icon size="32" class="text-f57"
								>mdi-file-search-outline</v-icon
							>
							<v-flex class="ml-6">
								<base-h1>200</base-h1>
								<base-text h2 normal>To Review</base-text>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<v-card width="310">
					<v-card-text class="px-9 pt-4 pb-6">
						<v-layout>
							<v-icon size="32" class="text-f57"
								>mdi-clock-outline</v-icon
							>
							<v-flex class="ml-6">
								<base-h1>0</base-h1>
								<base-text h2 normal>Pending</base-text>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-layout>
		</v-layout>

		<v-tabs
			v-model="currentTeam"
			hide-slider
			class="mt-13 >*:bg-transp inbox__team-tabs"
		>
			<v-tab v-for="team in teams" :key="team.id" :value="team.id">
				<base-text h2 tag="span" color="068">
					{{ team.text }}
				</base-text>
			</v-tab>
		</v-tabs>

		<v-card class="elevation-1">
			<v-card-text>
				<v-container fluid class="pb-0">
					<v-row>
						<v-col cols="6" md="3">
							<v-text-field
								placeholder="Search"
								dense
								outlined
								clearable
								hide-details
								class="base-input"
							/>
						</v-col>
						<v-col cols="6" md="2">
							<v-select
								prefix="Assignee"
								class="base-input"
								dense
								outlined
								clearable
								hide-details
							/>
						</v-col>
						<v-col cols="6" md="2">
							<v-select
								prefix="Status"
								class="base-input"
								dense
								outlined
								clearable
								hide-details
							/>
						</v-col>
						<v-col cols="6" md="2">
							<v-select
								class="base-input"
								prefix="Date Created"
								dense
								outlined
								clearable
								hide-details
							/>
						</v-col>
						<v-col cols="6" md="2">
							<v-select
								class="base-input"
								prefix="Date Updated"
								dense
								outlined
								clearable
								hide-details
							/>
						</v-col>
						<v-col cols="6" md="1" class="d-flex align-center">
							<base-text link>Reset filters</base-text>
						</v-col>
					</v-row>

					<v-layout
						v-show="selected.length"
						align-center
						class="mt-4 space-x-2"
					>
						<base-text>{{ selected.length }} emails selected</base-text>
						<v-menu offset-y>
							<template #activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									x-small
									outlined
									width="36"
									height="28"
									min-width="36"
									class="border-c5c base-shadow"
								>
									<v-icon class="text-c5c">mdi-dots-horizontal</v-icon>
								</v-btn>
							</template>
							<v-card outlined>
								<v-list dense class="pa-0">
									<v-list-item>
										<base-text small color="272" tag="span">
											Assign to a new team member
										</base-text>
									</v-list-item>
									<v-divider />
									<v-dialog
										v-model="dialogAssignToNewTeam"
										max-width="558"
										content-class="rounded-base"
									>
										<template #activator="{ on, attrs }">
											<v-list-item v-on="on" v-bind="attrs">
												<base-text small color="272" tag="span">
													Assign to a new team
												</base-text>
											</v-list-item>
										</template>

										<v-card>
											<v-toolbar class="base-shadow">
												<v-toolbar-title>
													<base-text color="0f3" h2>
														Quick actions: Assign to a new team
													</base-text>
												</v-toolbar-title>
												<v-spacer />
												<v-btn
													icon
													@click="dialogAssignToNewTeam = false"
												>
													<v-icon size="30" color="#0F395D">
														mdi-close
													</v-icon>
												</v-btn>
											</v-toolbar>
											<v-card-text class="mt-7">
												<v-card outlined flat>
													<v-card-text>
														<base-text bold color="707">
															{{ selected.length }} emails
															selected
														</base-text>
														<base-text color="707">
															{{
																selected
																	.map((v) => v.id)
																	.join(', ')
															}}
														</base-text>
													</v-card-text>
												</v-card>

												<div class="mt-7">
													<base-text color="272">
														Select a team to assign emails to
													</base-text>
													<v-select
														:items="['Team 1']"
														dense
														outlined
														clearable
														hide-details
														class="base-input mt-2"
													>
														<template #selection="{ item }">
															<base-text
																normal
																tag="span"
																color="272"
															>
																{{ item }}
															</base-text>
														</template>
													</v-select>
												</div>
											</v-card-text>
											<v-card-actions class="px-6 pb-8">
												<base-btn>
													<span>Apply Changes</span>
												</base-btn>
												<base-btn
													secondary
													@click="dialogAssignToNewTeam = false"
												>
													<span>Cancel</span>
												</base-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
									<v-divider />
									<v-list-item>
										<base-text small color="272" tag="span">
											Change Status
										</base-text>
									</v-list-item>
								</v-list>
							</v-card>
						</v-menu>
					</v-layout>
				</v-container>
			</v-card-text>
		</v-card>

		<v-data-table
			v-model="selected"
			:items="desserts"
			:headers="headers"
			show-select
			item-key="id"
			class="elevation-1 mt-4 base-data-table"
		>
			<!-- <template v-slot:header="{ props: { headers } }">
				<thead>
					<tr>
						<th v-for="(header, index) in headers" :key="index">
							{{ header.text }}
						</th>
					</tr>
				</thead>
			</template> -->

			<!-- <template v-slot:header.data-table-select="{ on, props }">
				<v-simple-checkbox color="purple" v-bind="props" v-on="on" />
			</template> -->

			<template #item.id="{ item }">
				<div role="button" class="title link">
					{{ item.id }}
				</div>
			</template>
			<template #item.meta>
				<v-badge class="base-badge ml-4" left offset-y="28" offset-x="-12">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="34.794"
						height="31.307"
						viewBox="0 0 34.794 31.307"
					>
						<g
							id="Group_19"
							data-name="Group 19"
							transform="translate(-1798.423 -676.068)"
						>
							<path
								id="Path_3527"
								data-name="Path 3527"
								d="M16.935,3.169a2.164,2.164,0,0,1,3.769,0l15.23,26.978a2.164,2.164,0,0,1-1.885,3.228H3.59a2.164,2.164,0,0,1-1.885-3.228Z"
								transform="translate(1797 674)"
								fill="#ffea77"
							/>
							<text
								id="_"
								data-name="!"
								transform="translate(1813.115 700.405)"
								fill="#707070"
								font-size="21"
								font-family="SegoeUI, Segoe UI"
							>
								<tspan x="0" y="0">!</tspan>
							</text>
						</g>
					</svg>
				</v-badge>
			</template>
			<template #item.subject="{ item }">
				<div class="title">{{ item.email }}</div>
				<div class="subtitle">{{ item.subject }}</div>
			</template>
			<template #item.emailReceived="{ item }">
				<div class="title">
					{{ $m(item.createdAt).format('YYYY-MM-DD') }}
				</div>
				<div class="subtitle">
					{{ $m(item.createdAt).format('HH:mm:ss') }}
				</div>
			</template>
			<template #item.attachmentsDetails="{ item }">
				<v-layout class="space-x-2">
					<v-flex
						v-for="type in item.attachmentsDetails"
						:key="type"
						shrink
						class="bg-f5f px-3 py-1 text-4 text-068"
					>
						{{ type }}
					</v-flex>
				</v-layout>
			</template>
			<template #item.status="{ item }">
				<v-chip>{{ item.status }}</v-chip>
			</template>
			<template #item.team="{ item }">
				<div class="title uppercase text-4">
					{{ item.team.name }}
				</div>
				<v-select
					:items="teamItems"
					outlined
					dense
					multiple
					class="base-input"
				>
					<template #selection="{ item }">
						<v-avatar size="44" dark color="primary" class="mr-2">
							<base-text h2 normal tag="span" class="white--text">
								{{ item.slice(0, 2) }}
							</base-text>
						</v-avatar>
					</template>
				</v-select>
			</template>
			<template #item.updatedAt="{ item }">
				<div class="title">
					{{ $m(item.updatedAt).format('YYYY-MM-DD') }}
				</div>
				<div class="subtitle">
					{{ $m(item.updatedAt).format('HH:mm:ss') }}
				</div>
			</template>
			<template #item.actions="{ item }">
				<v-layout class="space-x-4">
					<v-icon @click="drawerPreview = true">mdi-eye</v-icon>
					<v-btn
						x-small
						outlined
						height="28"
						width="36"
						min-width="36"
						class="border-c5c base-shadow"
						:to="`/inbox/${item.id}`"
					>
						<v-icon class="text-c5c">mdi-dots-horizontal</v-icon>
					</v-btn>
				</v-layout>
				<!-- v-on="on"
					v-bind="attrs" -->
				<!-- <v-menu>
					<template #activator="{ on, attrs }">
					</template>
					<v-card>
						<v-list>
							<v-list-item>
								<v-list-item-icon>mdi-open</v-list-item-icon>
							</v-list-item>
						</v-list>
					</v-card>
				</v-menu> -->
			</template>
		</v-data-table>

		<div class="inbox__drawer">
			<v-navigation-drawer v-model="drawerPreview" right fixed temporary>
				<v-layout column>
					<v-flex shrink>
						<v-toolbar class="elevation-3">
							<v-toolbar-title>
								<base-text link tag="span" color="368">
									Go to Document Audit
								</base-text>
							</v-toolbar-title>
							<v-spacer />
							<v-btn icon @click="drawerPreview = false">
								<v-icon size="32" class="text-0f3">mdi-close</v-icon>
							</v-btn>
						</v-toolbar>
					</v-flex>
					<v-flex>
						<PDFViewer class="inbox__drawer-pdf bg-f5f" />
					</v-flex>
				</v-layout>
			</v-navigation-drawer>
		</div>
	</v-container>
</template>

<script>
import PDFViewer from '../components/PDFViewer.vue'

const STATUS = {
	READY_FOR_REVIEW: 'Ready for review',
	EXTRACTING: 'Extracting',
	RECEIVED: 'Received',
	APPROVED: 'Approved',
}

const STATUS_COLOR = {
	[STATUS.READY_FOR_REVIEW]: '#337EEB',
	[STATUS.EXTRACTING]: '#1E9EBE',
	[STATUS.RECEIVED]: '#4C4E50',
	[STATUS.APPROVED]: '#F57840',
}

export default {
	name: 'InboxView',
	data: () => ({
		STATUS,
		STATUS_COLOR,
		selected: [],
		currentTeam: 'all',
		drawerPreview: false,
		dialogAssignToNewTeam: false,
		teams: [
			{
				id: 1,
				text: 'Team 1',
			},
			{
				id: 2,
				text: 'Team 2',
			},
			{
				id: 3,
				text: 'Team 3',
			},
			{
				id: 'all',
				text: 'All Teams',
			},
		],
		teamItems: ['Julie Stone', 'Lauren Wheatley', 'Dan Aronson'],
		headers: [
			{ text: '', value: 'meta', align: 'center' },
			{ text: 'ID', value: 'id' },
			{ text: 'FROM / SUBJECT', value: 'subject' },
			{ text: 'EMAIL RECEIVED', value: 'emailReceived' },
			{ text: 'ATTCHMENTS DETAILS', value: 'attachmentsDetails' },
			{ text: 'STATUS', value: 'status' },
			{ text: 'ASSIGNEE/TEAM', value: 'team' },
			{ text: 'LAST UPDATED', value: 'updatedAt' },
			{ text: '', value: 'actions' },
		],
		desserts: [
			{
				id: 1001,
				email: 'bli@superavocado.com',
				subject: 'COA for this week’s shipment',
				attachmentsDetails: ['POD', 'COA', 'BOL', 'PL', 'CI'],
				status: STATUS.READY_FOR_REVIEW,
				team: {
					id: 1,
					name: 'Julie Stone',
				},
				createdAt: new Date('2022-09-16'),
				updatedAt: new Date(),
			},
			{
				id: 2695,
				email: 'bli@superavocado.com',
				subject: 'COA for this week’s shipment',
				attachmentsDetails: ['POD', 'COA', 'BOL', 'PL', 'CI'],
				status: STATUS.EXTRACTING,
				team: {
					id: 1,
					name: 'Julie Stone',
				},
				createdAt: new Date('2022-09-16'),
				updatedAt: new Date(),
			},
			{
				id: 5863,
				email: 'bli@superavocado.com',
				subject: 'COA for this week’s shipment',
				attachmentsDetails: ['POD', 'COA', 'BOL', 'PL', 'CI'],
				status: STATUS.RECEIVED,
				team: {
					id: 1,
					name: 'Julie Stone',
				},
				createdAt: new Date('2022-09-16'),
				updatedAt: new Date(),
			},
			{
				id: 6984,
				email: 'bli@superavocado.com',
				subject: 'COA for this week’s shipment',
				attachmentsDetails: ['POD', 'COA', 'BOL', 'PL', 'CI'],
				status: STATUS.APPROVED,
				team: {
					id: 1,
					name: 'Julie Stone',
				},
				createdAt: new Date('2022-09-16'),
				updatedAt: new Date(),
			},
		],
	}),
	created() {
		// this.$m.utc()
	},
	components: { PDFViewer },
}
</script>
<style lang="scss">
.inbox {
	position: relative;
	&__team {
		&-tabs {
			.v-tab {
				padding: 1.25rem 2rem !important;
				&--active {
					position: relative;
					background-color: white;
					box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
						0px 1px 1px 0px rgb(0 0 0 / 14%),
						0px 1px 3px 0px rgb(0 0 0 / 12%) !important;
					&::after {
						content: '';
						bottom: 0;
						left: 50%;
						width: 75%;
						height: 2px;
						position: absolute;
						transform: translateX(-50%);
						background-color: black;
					}
				}
			}
		}
	}
	.v-data-table {
		thead {
			tr {
				th {
					span {
						opacity: 50%;
						font-size: 17px !important;
						color: #0685af !important;
					}
				}
			}
		}
	}
	&__drawer {
		.v-navigation-drawer {
			top: 82px !important;
			width: 100% !important;
			max-width: 1224px !important;
			height: calc(100vh - 82px) !important;
			&__content {
				display: flex;
				overflow: hidden !important;
				flex-direction: column;
			}
		}
		&-pdf {
			flex: 1;
			padding: 1.5rem;
		}
	}
}
</style>
